import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { SEARCH_SECTION_TABS } from '@Pages/QueryBuilder/QueryletConstants';
import { TabGroup, TabPanel } from '@els/els-react--tab-group';
import FieldsTab from '@Pages/QueryBuilder/SearchSection/SectionsTabs/FieldsTab';
import FormsTab from '@Pages/QueryBuilder/SearchSection/SectionsTabs/FormsTab';
import { searchSectionOpenedTab as searchSectionOpenedTabSelector } from '@Pages/QueryBuilder/QuerySelector';
import { setSearchSectionOpenedTab as setSearchSectionOpenedTabAction } from '@Pages/QueryBuilder/QueryletActions';

function SectionsTabs({ collectedFields, collectedForms, getForms, addToBuilder }) {
  const dispatch = useDispatch();
  const tabGroupRef = useRef();
  // Opened tab from Redux
  const searchSectionOpenedTab = useSelector(searchSectionOpenedTabSelector);
  const setSearchSectionOpenedTab = (_tabIndex) => dispatch(setSearchSectionOpenedTabAction(SEARCH_SECTION_TABS[_tabIndex]));

  const handleTabChange = (_tabIndex) => {
    setSearchSectionOpenedTab(_tabIndex);
  };

  useEffect(() => {
    const tabIndex = SEARCH_SECTION_TABS.indexOf(searchSectionOpenedTab);
    tabGroupRef?.current?.setActiveTab(tabIndex);
  }, [searchSectionOpenedTab]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const tabPanels = tabGroupRef?.current?.querySelectorAll?.('[role="tabpanel"]') || [];
      const activeTabIndex = SEARCH_SECTION_TABS.indexOf(searchSectionOpenedTab);

      tabPanels.forEach((panel, index) => {
        panel.setAttribute('tabindex', '-1');

        if (index === activeTabIndex) {
          panel.removeAttribute('hidden');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          panel.setAttribute('hidden', '');
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [searchSectionOpenedTab]);

  return (
    <TabGroup
      ref={tabGroupRef}
      id="querybuilder-tabs"
      label="Query Builder Search Sections"
      isControlled
      tabs={SEARCH_SECTION_TABS}
      hasDivider
      noDropdown
      onTabChange={handleTabChange}>
      <TabPanel panelId="0">
        <FieldsTab nodes={collectedFields} addToBuilder={addToBuilder} />
      </TabPanel>
      <TabPanel panelId="1">
        <FormsTab nodes={collectedForms} getForms={getForms} addToBuilder={addToBuilder} />
      </TabPanel>
    </TabGroup>
  );
}

SectionsTabs.propTypes = {
  collectedFields: PropTypes.array.isRequired,
  collectedForms: PropTypes.array.isRequired,
  getForms: PropTypes.func.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default SectionsTabs;
